import CreatableSelect from 'react-select/creatable'
import {MultiValue, ActionMeta} from 'react-select'
import {OptionTypeWithoutId} from '../core/_model'
import {FormikValues} from 'formik'

type OptionType = {
  value: string
  label: string
}

type Props = {
  selectedOptions: OptionTypeWithoutId[]
  onSelectMsisdn?: (number: string) => void
  formik?: FormikValues
  fieldname: string
}

const MultiSelectNumber = ({selectedOptions, onSelectMsisdn, formik, fieldname}: Props) => {
  // Handler for when the user selects or creates an option
  const handleChange = (selected: MultiValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
    // setSelectedOptions(selected as OptionType[])
    formik && formik.setFieldValue(fieldname!, selected as OptionType[])
  }

  // Handler for when the user creates a new option
  const handleCreate = (inputValue: string) => {
    const newOption: OptionType = {value: inputValue, label: inputValue}
    formik &&
      formik.setFieldValue(fieldname!, [...formik.values[fieldname], newOption] as OptionType[])
  }

  return (
    <div>
      <CreatableSelect
        isMulti
        className='react-select-styled react-select custom-input w-100'
        classNamePrefix='react-select'
        options={selectedOptions} // Current options
        value={selectedOptions} // Selected values
        onChange={handleChange}
        onCreateOption={handleCreate}
        placeholder='Type msisdn...'
        noOptionsMessage={() => 'Type msisdn to add it'}
        formatCreateLabel={(inputLable) => `Add ${inputLable}`}
      />
    </div>
  )
}

export default MultiSelectNumber
